"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WizardDialog = void 0;
const react_1 = __importDefault(require("react"));
const components_1 = require("@veeam/components");
const types_1 = require("../../types");
const WizardDialog = ({ actions, currentStep, currentStepIdx, enableStepsSchema, hasTopPadding = true, header = '', height = types_1.WIZARD_SIZE.m, id, loading, onKeyPress, onRequestClose, ref, selectHandler, steps, style, width = types_1.WIZARD_SIZE.m, }) => {
    const dialogActions = actions.reduce((acc, curr) => {
        if ('text' in curr && typeof curr.id === 'string') {
            acc[curr.id] = {
                text: curr.text,
                disabled: curr.disabled,
                didSelect: curr.onClick,
            };
        }
        return acc;
    }, {
        prev: { disabled: true },
        next: { disabled: true },
        skip: { disabled: true },
        done: { disabled: true },
        cancel: { disabled: true },
    });
    return (react_1.default.createElement(components_1.DialogWizardLayout, { "data-selector-id": id, style: style, ref: ref, dialogHeader: header, size: { width, height }, loading: !!loading, onRequestClose: onRequestClose, onKeyPress: onKeyPress, tabs: react_1.default.createElement(components_1.TabList, { items: steps.reduce((tabs, step, idx) => {
                if (!step.hidden) {
                    tabs.push({
                        title: step.tabTitle,
                        active: idx === currentStepIdx,
                        disabled: step.disabled || !enableStepsSchema[step.tag],
                        onClick: () => {
                            if (!step.disabled && enableStepsSchema[step.tag]) {
                                selectHandler(idx);
                            }
                        },
                    });
                }
                return tabs;
            }, []) }), contentHeader: react_1.default.createElement(components_1.DialogWizardContentHeader, { title: currentStep.title, description: currentStep.description }), content: react_1.default.createElement(components_1.DialogWizardStepContent, { hasTopPadding: hasTopPadding }, currentStep.body), footer: react_1.default.createElement(components_1.DialogWizardActions, Object.assign({}, dialogActions)) }));
};
exports.WizardDialog = WizardDialog;
exports.WizardDialog.displayName = 'WizardDialog';
//# sourceMappingURL=WizardDialog.js.map